export type AffinityStripePaymentState = Readonly<{
    isInitialising: boolean;
    isInitialised: boolean;
    stripeKey: string | undefined;
}>;

export const initialState: AffinityStripePaymentState = {
    isInitialising: false,
    isInitialised: false,
    stripeKey: undefined,
};

export default AffinityStripePaymentState;